export enum CLIENT_INVOICE_COLUMN_NAME {
  // sl.no., pdf file download button, invoice start date, invoice end date, invoice generation date
  SL_NO = "slNo",
  INVOICE_ID = "clientInvoiceId",
  ASSOCIATED_STORES = "stores",
  INVOICE_START_DATE = "startDateRange",
  INVOICE_END_DATE = "endDateRange",
  INVOICE_GENERATION_DATE = "invoiceDate",
  INVOICE_STATUS = "invoiceStatus",
  AUTO_GENERATED = "isAutoGenerated",
  CREATED_ON = "createdOn",
  UPDATED_ON = "updatedOn",
  ASSOCIATED_FDPS = "fdpCompanyNames",
  SUBMIT_DATE = "submitDate",
  NET_PAYMENT = "fdcTotalNetPayment"
}

export enum CLIENT_INVOICE_LABEL_NAME {
  SL_NO = "Sl. No.",
  INVOICE_ID = "Invoice Id",
  ASSOCIATED_STORES = "Associated Stores",
  INVOICE_START_DATE = "Start Date",
  INVOICE_END_DATE = "End Date",
  INVOICE_GENERATION_DATE = "Generation Date",
  INVOICE_STATUS = "Status",
  AUTO_GENERATED = "Auto Generated",
  CREATED_ON = "Created On",
  UPDATED_ON = "Updated On",
  ASSOCIATED_FDPS = "Associated FDPs",
  SUBMIT_DATE = "Submit Date",
  NET_PAYMENT = "Net Payment ($)"
}

export interface ClientInvoiceListDataArgs {
  pageIndex: number;
  pageSize: number;
}

export enum CLIENT_INVOICE_EDIT_COLUMN_NAME {
  ID = "id",
  START_DATE = "editStartRange",
  END_DATE = "editEndRange",
  STORE_ID = "storeId",
  TRIP_ID = "tripId",
  TOTAL_ORDERS = "totalOrders",
  ORDERS_DELIVERED = "ordersDelivered",
  ORDERS_UNDELIVERED = "ordersUndelivered",
  ORDERS_UNDELIVERED_NO_ATTEMPT = "ordersUndeliveredNoAttempt",
  RATECARD_EDITED = "isRatecardEdited",
  CLIENT_NAME = "clientName",
}

export enum CLIENT_INVOICE_EDIT_LABEL_NAME {
  ID = "Id",
  START_DATE = "Start Date",
  END_DATE = "End Date",
  STORE_ID = "Store Id",
  TRIP_ID = "Trip Id",
  TOTAL_ORDERS = "Total Orders",
  ORDERS_DELIVERED = "Orders Delivered",
  ORDERS_UNDELIVERED = "Orders Undelivered",
  ORDERS_UNDELIVERED_NO_ATTEMPT = "Orders Undelivered No Attempt",
  RATECARD_EDITED = "Rate Edited?",
  CLIENT_NAME = "Client Name",
}

export const CLIENT_INVOICE_STATUS = {
  GENERATED: "generated",
  DRAFT: "draft",
  OPS_EDITED: "ops_edited",
  OPS_APPROVED: "ops_approved",
  OPS_REVIEW: "ops_review",
  OPS_REVALIDATE: "ops_revalidate",
  FIN_EDITED: "fin_edited",
  FIN_APPROVED: "fin_approved",
  SUBMIT: "submit",
  SENT: "sent",
  REJECTED: "rejected",
};
